import { render, staticRenderFns } from "./ProofOfStaking.vue?vue&type=template&id=7f254ed6&"
import script from "./ProofOfStaking.vue?vue&type=script&lang=js&"
export * from "./ProofOfStaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports